import { lazy, Suspense } from "react";
import { PATHS } from "@/lib/router";
import { Navigate } from "react-router-dom";
import { RouteLoading } from "@/components/common";
import { FeatureProvider } from "@/lib/i18n";
import { Feature_NAMESPACES } from "@/lib/i18n";

const TargetSummaryPage = lazy(() => import("./pages/TargetSummaryPage"));
const ESGInviteAcceptPage = lazy(() => import("./pages/ESGInviteAcceptPage"));
const PreviewReportPage = lazy(() => import("./pages/PreviewReportPage"));
const ReportListPage = lazy(() => import("./pages/ReportListPage"));
const MetricsAssignmentPage = lazy(
  () => import("./pages/MetricsAssignmentPage"),
);
const AssignMasterData = lazy(() => import("./pages/AssignMasterData"));

const EsgForm = lazy(() => import("../onboarding/components/EsgForm"));

export const esgRoutes = [
  {
    path: PATHS.ESG_TARGETS,
    element: <Navigate to={PATHS.TARGET_SETUP} replace />,
    handle: { permission: { resource: "target_setting", action: "view" } },
  },
  {
    path: "/esg/targets-v2/*",
    element: <Navigate to={PATHS.TARGET_SETUP} replace />,
    handle: { permission: { resource: "target_setting", action: "view" } },
  },
  {
    path: "/esg/targets/details/*",
    element: <Navigate to={PATHS.TARGET_SETUP} replace />,
    handle: { permission: { resource: "target_setting", action: "view" } },
  },
  {
    path: PATHS.ESG_MASTER_DATA,
    element: (
      <FeatureProvider namespace={Feature_NAMESPACES.METRIC_ASSIGNMENT}>
        <MetricsAssignmentPage />
      </FeatureProvider>
    ),
    handle: { permission: { resource: "master_data", action: "view" } },
  },
  {
    path: PATHS.ESG_MASTER_DATA_ASSIGN,
    element: (
      <FeatureProvider namespace={Feature_NAMESPACES.METRIC_ASSIGNMENT}>
        <AssignMasterData />
      </FeatureProvider>
    ),
    handle: {
      permission: { resource: "master_data", action: "create" },
      blacklistGroup: ["user"],
    },
  },
  {
    path: `${PATHS.ESG_TARGETS_SUMMARY}/:targetId`,
    element: <TargetSummaryPage />,
    handle: { permission: { resource: "target_setting", action: "view" } },
  },
  {
    path: PATHS.ESG_REPORT_PREVIEW,
    element: (
      <FeatureProvider namespace={Feature_NAMESPACES.ESG}>
        <PreviewReportPage />
      </FeatureProvider>
    ),
    handle: { permission: { resource: "esg_reporting", action: "view" } },
  },
  {
    path: PATHS.ESG_REPORT_PREVIEW_LIST,
    element: (
      <FeatureProvider namespace={Feature_NAMESPACES.ESG}>
        <ReportListPage />
      </FeatureProvider>
    ),
    handle: { permission: { resource: "esg_reporting", action: "view" } },
  },
];

export const esgPublicRoutes = [
  {
    path: PATHS.ESG_INVITE_ACCEPT,
    element: (
      <Suspense fallback={<RouteLoading />}>
        <ESGInviteAcceptPage />
      </Suspense>
    ),
  },
  {
    path: PATHS.ESG_FRAMEWORKS,
    element: (
      <Suspense fallback={<RouteLoading />}>
        <EsgForm />
      </Suspense>
    ),
    handle: { permission: { resource: "reports", action: "view" } },
  },
];
